import * as classes from "./controls-instructions.module.scss";
import PointerIcon from "../../icons/PointerCursor.svg";
import ArrowKeys from "../../icons/ArrowKeys.svg";
import Joysticks from "../../icons/Joysticks.svg";
import { useContext } from "react";
import { AppContext, ControlsMode } from "../../contexts/AppContext";
import classNames from "classnames";

const ControlsInstructions = () => {
  const { state } = useContext(AppContext);
  const {
    isInit,
    isWorldLoading,
    isPointerLocked,
    showControlsMoveHint,
    controlsMode,
  } = state || {};

  if (controlsMode === ControlsMode.Pointerlock) {
    return (
      <>
        <div
          aria-hidden={!(!isPointerLocked && isInit && !isWorldLoading)}
          className={classNames(classes.root, {
            [classes["root--is-visible"]]:
              !isPointerLocked && isInit && !isWorldLoading,
          })}
        >
          <PointerIcon className={classes["pointer-icon"]} />
          Click to
          <br />
          look around
        </div>
        <div
          aria-hidden={!(isPointerLocked && showControlsMoveHint)}
          className={classNames(classes.root, {
            [classes["root--is-visible"]]:
              isPointerLocked && showControlsMoveHint,
          })}
        >
          <ArrowKeys />
          Use arrow keys
          <br />
          to move
        </div>
        <div
          aria-hidden={!isPointerLocked}
          className={classNames(classes["escape-to-exit"], {
            [classes["escape-to-exit--is-visible"]]: isPointerLocked,
          })}
        >
          Press <span className={classes["escape-to-exit__esc"]}>esc</span> to
          show cursor
        </div>
      </>
    );
  }

  if (controlsMode === ControlsMode.Joystick && showControlsMoveHint) {
    return (
      <div
        className={classNames(classes.root, {
          [classes["root--is-visible"]]: true,
        })}
      >
        <Joysticks />
        Use Left Joystick to Walk <br />
        and Right Joystick to Look Around
      </div>
    );
  }

  return null;
};

export default ControlsInstructions;
